import { render } from "./ArticleSlider.vue?vue&type=template&id=05d61ed4&scoped=true"
import script from "./ArticleSlider.vue?vue&type=script&lang=js"
export * from "./ArticleSlider.vue?vue&type=script&lang=js"

import "./ArticleSlider.vue?vue&type=style&index=0&id=05d61ed4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d61ed4"]])

export default __exports__